var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel-content',_vm._g(_vm._b({staticClass:"app-expansion-panel",class:_vm.noPadding ? 'no-padding' : ''},'v-expansion-panel-content',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }